import { useQueryClient } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { useState } from 'react';
import { createAppRouter } from './router.js';

/// A aplicação inteira é a árvore de rotas.
///
/// Até aqui a posição da pessoa morava em `useState` e a URL só existia para os quatro links que
/// chegam por e-mail, com um roteador manual de `pushState` e `popstate` neste arquivo. A decisão
/// de trocar isso — e por quê — está em `docs/adr/0009`.
export function App() {
  const queryClient = useQueryClient();
  const [router] = useState(() => createAppRouter(queryClient));
  return <RouterProvider router={router} />;
}
